import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';
import 'bootstrap/dist/css/bootstrap.min.css';
import './home/styles/common-styles.scss'
import ErrorBoundary from "./error-boundary";

console.log(window)

// ReactDOM.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>,
//   document.getElementById('root')
// );

ReactDOM.render(
  <>
    <App />
  </>,
  document.getElementById('root')
);

// ReactDOM.render(
//   <ErrorBoundary>
//     <App />
//   </ErrorBoundary>,
//   document.getElementById("root")
// );


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
